import React, { Component } from 'react';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { Typography } from '@material-ui/core';
import HOCLoader from '../HOC/HOCLoader.jsx';
class StartFrom extends Component {
    render() {
        const { price } = this.props;
        if (price) {
            return (
                <Typography
                    color={'primary'}
                    component="h6"
                    style={{ fontWeight: 'bold', marginLeft: '5px' }}
                >
                    BD
                    {price}
                </Typography>
            );
        }
    }
}
export default withCustomTheme(StartFrom);



// WEBPACK FOOTER //
// ./src/components/Providers/StartFrom.js